<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>集团管理</el-breadcrumb-item>
      <el-breadcrumb-item>打卡管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 统计卡片 -->
    <el-row :gutter="16" style="margin-top:16px">
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background:#409EFF20">
            <i class="el-icon-location" style="color:#409EFF"></i>
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ stats.total_checkins }}</div>
            <div class="stat-label">周期内打卡总次数</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background:#67C23A20">
            <i class="el-icon-user" style="color:#67C23A"></i>
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ stats.total_users }}</div>
            <div class="stat-label">打卡人数</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background:#E6A23C20">
            <i class="el-icon-date" style="color:#E6A23C"></i>
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ stats.today_checkins }}</div>
            <div class="stat-label">今日打卡次数</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-icon" style="background:#F56C6C20">
            <i class="el-icon-office-building" style="color:#F56C6C"></i>
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ companyList.length }}</div>
            <div class="stat-label">公司数量</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 打卡趋势图 + Top10 -->
    <el-row :gutter="16" style="margin-top:16px">
      <el-col :span="16">
        <el-card shadow="hover">
          <div slot="header" class="card-header">
            <span>打卡趋势（近30天）</span>
          </div>
          <div ref="trendChart" style="height:220px"></div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" style="height:100%">
          <div slot="header" class="card-header">
            <span>打卡 Top 10</span>
          </div>
          <div class="top-list">
            <div v-for="(item, index) in stats.top_users" :key="index" class="top-item">
              <span class="top-rank" :class="'rank-' + (index + 1)">{{ index + 1 }}</span>
              <span class="top-name">{{ item.name }}</span>
              <span class="top-company">{{ item.company }}</span>
              <el-tag size="mini" type="success">{{ item.checkin_count }} 次</el-tag>
            </div>
            <div v-if="!stats.top_users || !stats.top_users.length" class="empty-tip">暂无数据</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 工时统计面板 -->
    <el-card style="margin-top:16px" v-loading="workHoursLoading">
      <div slot="header" class="card-header" style="display:flex;align-items:center;justify-content:space-between">
        <span>工时统计</span>
        <div>
          <el-date-picker v-model="workDateRange" type="daterange" size="small"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            value-format="yyyy-MM-dd" style="width:220px;margin-right:8px"
            @change="loadWorkHours">
          </el-date-picker>
          <el-button size="small" type="success" icon="el-icon-download" @click="exportWorkHours">导出工时</el-button>
        </div>
      </div>
      <el-table :data="workHoursList" border stripe size="small">
        <el-table-column prop="work_date"  label="日期"     width="110" align="center">
          <template slot-scope="scope">{{ scope.row.work_date | workDateFormat }}</template>
        </el-table-column>
        <el-table-column prop="name"       label="姓名"     width="90"></el-table-column>
        <el-table-column prop="mobile"     label="手机号"   width="120"></el-table-column>
        <el-table-column prop="company"    label="所属公司" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="上班时间" width="90" align="center">
          <template slot-scope="scope">
            <span style="color:#67C23A;font-weight:bold">{{ scope.row.clock_in_time | timeOnlyFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="下班时间" width="90" align="center">
          <template slot-scope="scope">
            <span style="color:#F56C6C;font-weight:bold">{{ scope.row.clock_out_time | timeOnlyFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上班地址" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.clock_in_address">{{ scope.row.clock_in_address }}</span>
            <span v-else style="color:#c0c4cc">—</span>
          </template>
        </el-table-column>
        <el-table-column label="下班地址" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.clock_out_address">{{ scope.row.clock_out_address }}</span>
            <span v-else style="color:#c0c4cc">—</span>
          </template>
        </el-table-column>
        <el-table-column label="工时" width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.work_hours_label" size="small" type="success">
              {{ scope.row.work_hours_label }}
            </el-tag>
            <span v-else style="color:#c0c4cc">—</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.clock_in_time && scope.row.clock_out_time" size="mini" type="success">已完成</el-tag>
            <el-tag v-else-if="scope.row.clock_in_time" size="mini" type="warning">待下班</el-tag>
            <el-tag v-else size="mini" type="danger">缺卡</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top:10px" small
        @current-change="handleWorkHoursPageChange"
        :current-page="workHoursQuery.page"
        :page-size="workHoursQuery.limit"
        layout="total, prev, pager, next"
        :total="workHoursTotal">
      </el-pagination>
    </el-card>

    <!-- 筛选 + 列表 -->
    <el-card style="margin-top:16px">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="姓名/手机">
          <el-input
            v-model="query.keyword"
            placeholder="姓名或手机号"
            clearable
            style="width:160px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属公司">
          <el-select v-model="query.company" placeholder="全部" clearable style="width:160px">
            <el-option v-for="c in companyList" :key="c" :label="c" :value="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打卡日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width:240px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button type="success" icon="el-icon-download" @click="handleExport">导出 CSV</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe v-loading="loading" style="margin-top:8px">
        <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
        <el-table-column prop="name"    label="姓名"   width="90"></el-table-column>
        <el-table-column prop="mobile"  label="手机号" width="120"></el-table-column>
        <el-table-column prop="company" label="所属公司" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="打卡类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="scope.row.checkin_type === 'clock_in' ? 'success' : (scope.row.checkin_type === 'clock_out' ? 'danger' : 'info')"
            >
              {{ scope.row.checkin_type === 'clock_in' ? '上班' : (scope.row.checkin_type === 'clock_out' ? '下班' : '打卡') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="打卡地址" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="省市区" width="180">
          <template slot-scope="scope">
            {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.district }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.remark">{{ scope.row.remark }}</span>
            <span v-else style="color:#c0c4cc">—</span>
          </template>
        </el-table-column>
        <el-table-column label="打卡时间" width="160">
          <template slot-scope="scope">{{ scope.row.checkin_time | dataFormat }}</template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-location" @click="showMap(scope.row)">地图</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top:12px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.page"
        :page-sizes="[20, 50, 100]"
        :page-size="query.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 打卡日志面板（farmer_checkin_logs，每次打卡均记录） -->
    <el-card style="margin-top:16px" v-loading="logLoading">
      <div slot="header" class="card-header" style="display:flex;align-items:center;justify-content:space-between">
        <span>打卡日志 <span style="color:#909399;font-size:12px;font-weight:normal">（每次打卡均记录，含重复打卡）</span></span>
        <div style="display:flex;align-items:center;gap:8px">
          <el-input v-model="logQuery.keyword" placeholder="姓名/手机" clearable size="small"
            style="width:130px" @keyup.enter.native="searchLogs"></el-input>
          <el-select v-model="logQuery.company" placeholder="全部公司" clearable size="small" style="width:130px">
            <el-option v-for="c in companyList" :key="c" :label="c" :value="c"></el-option>
          </el-select>
          <el-select v-model="logQuery.checkin_type" placeholder="全部类型" clearable size="small" style="width:100px">
            <el-option label="上班" value="clock_in"></el-option>
            <el-option label="下班" value="clock_out"></el-option>
          </el-select>
          <el-date-picker v-model="logDateRange" type="daterange" size="small"
            range-separator="至" start-placeholder="开始" end-placeholder="结束"
            value-format="yyyy-MM-dd" style="width:220px" @change="searchLogs">
          </el-date-picker>
          <el-button size="small" type="primary" icon="el-icon-search" @click="searchLogs">查询</el-button>
          <el-button size="small" icon="el-icon-refresh" @click="resetLogs">重置</el-button>
          <el-button size="small" type="success" icon="el-icon-download" @click="exportLogs">导出</el-button>
        </div>
      </div>

      <el-table :data="logList" border stripe size="small" style="margin-top:4px">
        <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
        <el-table-column prop="name"    label="姓名"   width="90"></el-table-column>
        <el-table-column prop="mobile"  label="手机号" width="120"></el-table-column>
        <el-table-column prop="company" label="所属公司" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="打卡类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini"
              :type="scope.row.checkin_type === 'clock_in' ? 'success' : (scope.row.checkin_type === 'clock_out' ? 'danger' : 'info')">
              {{ scope.row.checkin_type === 'clock_in' ? '上班' : (scope.row.checkin_type === 'clock_out' ? '下班' : '打卡') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="打卡地址" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="省市区" width="160">
          <template slot-scope="scope">{{ scope.row.province }}{{ scope.row.city }}{{ scope.row.district }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.remark">{{ scope.row.remark }}</span>
            <span v-else style="color:#c0c4cc">—</span>
          </template>
        </el-table-column>
        <el-table-column label="打卡时间" width="150" align="center">
          <template slot-scope="scope">{{ scope.row.checkin_time }}</template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-top:10px" small
        @size-change="handleLogSizeChange"
        @current-change="handleLogPageChange"
        :current-page="logQuery.page"
        :page-sizes="[20, 50, 100]"
        :page-size="logQuery.limit"
        layout="total, sizes, prev, pager, next"
        :total="logTotal">
      </el-pagination>
    </el-card>

    <!-- 地图弹窗 -->
    <el-dialog title="打卡位置" :visible.sync="mapDialogVisible" width="680px">
      <div v-if="currentRecord">
        <el-descriptions :column="2" border size="small" style="margin-bottom:12px">
          <el-descriptions-item label="姓名">{{ currentRecord.name }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ currentRecord.mobile }}</el-descriptions-item>
          <el-descriptions-item label="所属公司">{{ currentRecord.company }}</el-descriptions-item>
          <el-descriptions-item label="打卡类型">
            <el-tag size="mini"
              :type="currentRecord.checkin_type === 'clock_in' ? 'success' : (currentRecord.checkin_type === 'clock_out' ? 'danger' : 'info')">
              {{ currentRecord.checkin_type === 'clock_in' ? '上班' : (currentRecord.checkin_type === 'clock_out' ? '下班' : '打卡') }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="打卡时间">{{ currentRecord.checkin_time | dataFormat }}</el-descriptions-item>
          <el-descriptions-item label="打卡地址" :span="2">{{ currentRecord.address }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ currentRecord.remark || '—' }}</el-descriptions-item>
        </el-descriptions>
        <div class="map-preview">
          <img :src="getMapImageUrl(currentRecord)" alt="打卡位置" style="width:100%;border-radius:4px" />
          <div class="map-coords">坐标：{{ currentRecord.latitude }}, {{ currentRecord.longitude }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import echarts from 'echarts'

const AMAP_KEY = '7094d6e6f20ede19da379b01d7cf4dda'

export default {
  name: 'CheckinList',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: { page: 1, limit: 20, keyword: '', company: '' },
      dateRange: [],
      stats: { total_checkins: 0, total_users: 0, today_checkins: 0, trend: [], top_users: [] },
      companyList: [],
      mapDialogVisible: false,
      currentRecord: null,
      chart: null,
      workHoursList: [],
      workHoursTotal: 0,
      workHoursLoading: false,
      workDateRange: [],
      workHoursQuery: { page: 1, limit: 15 },
      // 打卡日志
      logList: [],
      logTotal: 0,
      logLoading: false,
      logDateRange: [],
      logQuery: { page: 1, limit: 20, keyword: '', company: '', checkin_type: '' }
    }
  },
  created() {
    this.getCompanyList()
    this.getStats()
    this.getList()
    this.loadWorkHours()
    this.loadLogs()
  },
  mounted() {
    this.$nextTick(() => { this.initChart() })
  },
  beforeDestroy() {
    if (this.chart) { this.chart.dispose(); this.chart = null }
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_date = this.dateRange[0]
          params.end_date   = this.dateRange[1]
        }
        const { data: res } = await this.$http.get('web_api/group/checkin_list', { params })
        if (res.code !== 200) return this.$message.error('获取打卡列表失败')
        this.list  = res.data.list  || []
        this.total = res.data.total || 0
      } catch (e) {
        this.$message.error('请求失败')
      } finally {
        this.loading = false
      }
    },

    async getStats() {
      try {
        const params = {}
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_date = this.dateRange[0]
          params.end_date   = this.dateRange[1]
        }
        if (this.query.company) params.company = this.query.company
        const { data: res } = await this.$http.get('web_api/group/checkin_stats', { params })
        if (res.code !== 200) return
        this.stats = res.data
        this.$nextTick(() => this.renderChart())
      } catch (e) { /* ignore */ }
    },

    async getCompanyList() {
      try {
        const { data: res } = await this.$http.get('web_api/group/company_list')
        if (res.code === 200) this.companyList = res.data || []
      } catch (e) { /* ignore */ }
    },

    handleSearch() {
      this.query.page = 1
      this.getList()
      this.getStats()
    },

    handleReset() {
      this.query = { page: 1, limit: 20, keyword: '', company: '' }
      this.dateRange = []
      this.getList()
      this.getStats()
    },

    handleSizeChange(val) { this.query.limit = val; this.query.page = 1; this.getList() },
    handleCurrentChange(val) { this.query.page = val; this.getList() },

    async handleExport() {
      try {
        const params = { ...this.query, page: 1, limit: 50000, export: '1' }
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_date = this.dateRange[0]
          params.end_date   = this.dateRange[1]
        }
        const { data: res } = await this.$http.get('web_api/group/checkin_list', { params })
        if (res.code !== 200 || !res.data.list.length) return this.$message.warning('暂无数据可导出')
        const rows = res.data.list
        const headers = ['姓名', '手机号', '所属公司', '打卡类型', '打卡地址', '省', '市', '区', '备注', '打卡时间']
        const csvRows = [
          headers.join(','),
          ...rows.map(r => [
            r.name, r.mobile, r.company,
            r.checkin_type === 'clock_in' ? '上班' : (r.checkin_type === 'clock_out' ? '下班' : '打卡'),
            `"${(r.address || '').replace(/"/g, '""')}"`,
            r.province, r.city, r.district,
            `"${(r.remark || '').replace(/"/g, '""')}"`,
            this.formatBeijingTime(r.checkin_time)
          ].join(','))
        ]
        const blob = new Blob(['\uFEFF' + csvRows.join('\n')], { type: 'text/csv;charset=utf-8' })
        const url  = URL.createObjectURL(blob)
        const a    = document.createElement('a')
        a.href     = url
        a.download = `打卡记录_${new Date().Format('yyyyMMdd')}.csv`
        a.click()
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      }
    },

    showMap(row) { this.currentRecord = row; this.mapDialogVisible = true },

    // 将时间字符串转换为北京时间（UTC+8）格式化输出
    // 数据库存储的是服务器本地时间，若服务器为 UTC，需手动 +8h
    formatBeijingTime(timeStr) {
      if (!timeStr) return ''
      const dt = new Date(timeStr)
      // 若 new Date() 解析后已是本地时间（服务器与数据库同区），直接格式化
      // 若数据库存的是 UTC，则需要 +8*3600*1000
      // 这里统一用 toLocaleString 指定时区，兼容两种情况
      const options = {
        timeZone: 'Asia/Shanghai',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      }
      // toLocaleString 返回格式因浏览器而异，手动拼接更稳定
      const bjDate = new Date(dt.toLocaleString('en-US', { timeZone: 'Asia/Shanghai' }))
      const y  = bjDate.getFullYear()
      const mo = String(bjDate.getMonth() + 1).padStart(2, '0')
      const d  = String(bjDate.getDate()).padStart(2, '0')
      const hh = String(bjDate.getHours()).padStart(2, '0')
      const mm = String(bjDate.getMinutes()).padStart(2, '0')
      const ss = String(bjDate.getSeconds()).padStart(2, '0')
      return `${y}-${mo}-${d} ${hh}:${mm}:${ss}`
    },

    getMapImageUrl(record) {
      const { longitude, latitude } = record
      return `https://restapi.amap.com/v3/staticmap?key=${AMAP_KEY}&location=${longitude},${latitude}&zoom=15&size=620*300&markers=mid,,A:${longitude},${latitude}`
    },

    initChart() {
      if (!this.$refs.trendChart) return
      this.chart = echarts.init(this.$refs.trendChart)
      window.addEventListener('resize', () => this.chart && this.chart.resize())
    },

    renderChart() {
      if (!this.chart) return
      const trend  = this.stats.trend || []
      const dates  = trend.map(t => t.checkin_date ? String(t.checkin_date).slice(0, 10) : '')
      const counts = trend.map(t => t.count)
      this.chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 40, right: 20, top: 20, bottom: 30 },
        xAxis: { type: 'category', data: dates, axisLabel: { fontSize: 11, rotate: dates.length > 15 ? 30 : 0 } },
        yAxis: { type: 'value', minInterval: 1 },
        series: [{
          name: '打卡次数',
          type: 'bar',
          data: counts,
          itemStyle: { color: '#409EFF', borderRadius: [3, 3, 0, 0] },
          label: { show: counts.length <= 15, position: 'top', fontSize: 11 }
        }]
      })
    },

    // ── 工时统计 ────────────────────────────────────────────
    async loadWorkHours() {
      this.workHoursLoading = true
      try {
        const params = { ...this.workHoursQuery }
        if (this.workDateRange && this.workDateRange.length === 2) {
          params.start_date = this.workDateRange[0]
          params.end_date   = this.workDateRange[1]
        }
        if (this.query.company) params.company = this.query.company
        if (this.query.keyword) params.keyword = this.query.keyword
        const { data: res } = await this.$http.get('web_api/group/work_hours', { params })
        if (res.code !== 200) return
        this.workHoursList  = res.data.list  || []
        this.workHoursTotal = res.data.total || 0
      } catch (e) {
        console.error('工时加载失败', e)
      } finally {
        this.workHoursLoading = false
      }
    },

    handleWorkHoursPageChange(val) {
      this.workHoursQuery.page = val
      this.loadWorkHours()
    },

    // ── 打卡日志 ────────────────────────────────────────────
    async loadLogs() {
      this.logLoading = true
      try {
        const params = { ...this.logQuery }
        if (this.logDateRange && this.logDateRange.length === 2) {
          params.start_date = this.logDateRange[0]
          params.end_date   = this.logDateRange[1]
        }
        const { data: res } = await this.$http.get('web_api/group/checkin_logs', { params })
        if (res.code !== 200) return
        this.logList  = res.data.list  || []
        this.logTotal = res.data.total || 0
      } catch (e) {
        console.error('日志加载失败', e)
      } finally {
        this.logLoading = false
      }
    },

    searchLogs() {
      this.logQuery.page = 1
      this.loadLogs()
    },

    resetLogs() {
      this.logQuery = { page: 1, limit: 20, keyword: '', company: '', checkin_type: '' }
      this.logDateRange = []
      this.loadLogs()
    },

    handleLogPageChange(val) { this.logQuery.page = val; this.loadLogs() },
    handleLogSizeChange(val) { this.logQuery.limit = val; this.logQuery.page = 1; this.loadLogs() },

    async exportLogs() {
      try {
        const params = { ...this.logQuery, page: 1, limit: 50000, export: '1' }
        if (this.logDateRange && this.logDateRange.length === 2) {
          params.start_date = this.logDateRange[0]
          params.end_date   = this.logDateRange[1]
        }
        const { data: res } = await this.$http.get('web_api/group/checkin_logs', { params })
        if (res.code !== 200 || !res.data.list.length) return this.$message.warning('暂无日志数据')
        const rows = res.data.list
        const headers = ['姓名', '手机号', '所属公司', '打卡类型', '打卡地址', '省', '市', '区', '备注', '打卡时间']
        const csvRows = [
          headers.join(','),
          ...rows.map(r => [
            r.name, r.mobile, r.company,
            r.checkin_type === 'clock_in' ? '上班' : (r.checkin_type === 'clock_out' ? '下班' : '打卡'),
            '"' + (r.address || '').replace(/"/g, '""') + '"',
            r.province, r.city, r.district,
            '"' + (r.remark  || '').replace(/"/g, '""') + '"',
            r.checkin_time || ''
          ].join(','))
        ]
        const blob = new Blob(['\uFEFF' + csvRows.join('\n')], { type: 'text/csv;charset=utf-8' })
        const url  = URL.createObjectURL(blob)
        const a    = document.createElement('a')
        a.href     = url
        a.download = '打卡日志_' + new Date().Format('yyyyMMdd') + '.csv'
        a.click()
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      }
    },

    async exportWorkHours() {
      try {
        const params = { page: 1, limit: 50000, export: '1' }
        if (this.workDateRange && this.workDateRange.length === 2) {
          params.start_date = this.workDateRange[0]
          params.end_date   = this.workDateRange[1]
        }
        if (this.query.company) params.company = this.query.company
        if (this.query.keyword) params.keyword = this.query.keyword
        const { data: res } = await this.$http.get('web_api/group/work_hours', { params })
        if (res.code !== 200 || !res.data.list.length) return this.$message.warning('暂无工时数据')
        const rows = res.data.list
        const headers = ['日期', '姓名', '手机号', '所属公司', '上班时间', '上班地址', '下班时间', '下班地址', '工时', '状态']
        const csvRows = [
          headers.join(','),
          ...rows.map(r => {
            const status = (r.clock_in_time && r.clock_out_time) ? '已完成'
              : (r.clock_in_time ? '待下班' : '缺卡')
            return [
              r.work_date ? String(r.work_date).slice(0, 10) : '',
              r.name, r.mobile, r.company,
              r.clock_in_time  || '',
              '"' + (r.clock_in_address  || '').replace(/"/g, '""') + '"',
              r.clock_out_time || '',
              '"' + (r.clock_out_address || '').replace(/"/g, '""') + '"',
              r.work_hours_label || '',
              status
            ].join(',')
          })
        ]
        const blob = new Blob(['\uFEFF' + csvRows.join('\n')], { type: 'text/csv;charset=utf-8' })
        const url  = URL.createObjectURL(blob)
        const a    = document.createElement('a')
        a.href     = url
        a.download = `工时统计_${new Date().Format('yyyyMMdd')}.csv`
        a.click()
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.stat-card :deep(.el-card__body) { display:flex; align-items:center; padding:16px; }
.stat-icon { width:52px; height:52px; border-radius:12px; display:flex; align-items:center; justify-content:center; flex-shrink:0; i { font-size:26px; } }
.stat-body { margin-left:14px; }
.stat-value { font-size:28px; font-weight:bold; color:#303133; line-height:1.2; }
.stat-label { font-size:12px; color:#909399; margin-top:4px; }
.card-header { font-weight:bold; font-size:14px; }
.top-list { max-height:220px; overflow-y:auto; }
.top-item { display:flex; align-items:center; padding:6px 0; border-bottom:1px solid #f0f0f0; &:last-child { border-bottom:none; } }
.top-rank { width:22px; height:22px; border-radius:50%; background:#dcdfe6; color:#606266; font-size:12px; font-weight:bold; display:flex; align-items:center; justify-content:center; flex-shrink:0; &.rank-1 { background:#f56c6c; color:#fff; } &.rank-2 { background:#e6a23c; color:#fff; } &.rank-3 { background:#67c23a; color:#fff; } }
.top-name { margin-left:8px; font-size:13px; font-weight:500; min-width:50px; }
.top-company { margin-left:6px; font-size:12px; color:#909399; flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.map-preview { border-radius:4px; overflow:hidden; background:#f5f7fa; }
.map-coords { font-size:12px; color:#909399; padding:6px 8px; text-align:center; }
.empty-tip { text-align:center; color:#c0c4cc; padding:20px 0; font-size:13px; }
</style>
